module.exports = __webpack_public_path__ + "img/logo-givenchy.2a08007b.jpg";